import type { Branded } from "@@/utilities/branded";
import { repeatIndex } from "@@/utilities/repeat";
import { z } from "zod";
import type { LanguageCode } from "../translations/language-code";
import { languageCodes } from "../translations/language-code";
import { translation } from "../translations/translation";
import { getLocale } from "./locales";

const monthNames = repeatIndex(12).map(index => {
    // index is a value from 0 - 11
    const date = new Date(0, index, 1);
    const result = languageCodes.reduce(
        (agg, languageCode) => {
            const locale = getLocale(languageCode);
            return {
                short: {
                    ...agg.short,
                    [languageCode]: new Intl.DateTimeFormat(locale.code, {
                        month: "short",
                    }).format(date),
                },
                long: {
                    ...agg.long,
                    [languageCode]: new Intl.DateTimeFormat(locale.code, {
                        month: "long",
                    }).format(date),
                },
            };
        },
        { short: translation({ sv: "" }), long: translation({ sv: "" }) } as {
            short: Record<LanguageCode, string>;
            long: Record<LanguageCode, string>;
        },
    );
    return result;
});

const months = repeatIndex(12).map(index => {
    return { month: index + 1, name: monthNames[index].long };
});

type MonthNumber = Branded<(typeof months)[number]["month"], "MonthNumber">;
const monthNumberZodSchema = z
    .number()
    .min(1)
    .max(12) as unknown as z.ZodSchema<MonthNumber>;

type Month = (typeof months)[number]["name"];

export { monthNames, monthNumberZodSchema, months };
export type { Month, MonthNumber };
